import Vue from 'vue';
import VueI18n from 'vue-i18n';
import es from '@/i18n/es.json'
import en from '@/i18n/en.json'
import store from '../store';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: store.getters['app/get_language'],
  fallbackLocale: 'en',
  messages: {es, en},
});

store.watch(
  (state) => state.app.language, 
  (language) => {
    i18n.locale = language;  
  }
);

export default i18n;
